<template>
<div>
  <div class="nav" id="nav">
    <van-nav-bar
    placeholder="placeholder"
    :title="navTitle"
    :left-text="leftText"
    :right-text="rightText"
    :left-arrow="leftArrow"
    @click-left="onClickLeft"
    @click-right="onClickRight"
     />
  </div>

</div>
</template>

<script>

export default {
  data() {
    return {
      placeholder: true
    }
  },
  props: {
    navTitle: {
      type: String,
      default: ""
    },
    leftText: {
      type: String,
      default: ""
    },
    rightText: {
      type: String,
      default: ""
    },
    leftArrow:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
    onClickRight()
    {
      this.$router.push({
        name: 'index'
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.nav{
  position:fixed;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 999;
}
.van-nav-bar
{
  background: #fff;
}




</style>
 <style lang="css" scoped>
 .nav >>> .van-nav-bar__content{
   height: 3.75rem;
 }
 .nav >>> .van-nav-bar__text{
   color: #323233;
   font-size: 1rem;
 }

 .nav >>>.van-nav-bar__title{
   color: #1989fa;
   font-size: 1rem;
   font-weight: bold;
 }
 </style>
